import socketClient from "../../websockets/client";

export const socketMiddleware = (storeAPI) => (next) => (action) => {
  if (action.type === "notifications/syncNotifications") {
    socketClient.on("notification", (notification) => {
      storeAPI.dispatch({
        type: "ADD_NOTIFICATIONS",
        payload: notification,
      });
    });
  }

  return next(action);
};

